import { Button } from "@fmc-digital/ui";
import { useRegistrationProvider } from "@profile/providers/RegistrationProvider";
import { useIsMinWidth768 } from "@profile/hooks/useIsMinWidth768";
import { useNavigate, useLocation } from "react-router-dom";
import { RegisterSuccessDecorations } from "./decorations";
import { REGISTRATION_ROUTES } from "@profile/constants/routes";

export function RegisterSuccessPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { buildImageUrl, config: registrationConfig } = useRegistrationProvider();
  const registeredEmail = (location.state as { username?: string } | null)?.username;
  const isWideLayout = useIsMinWidth768();
  const storeListingUrl = registrationConfig.mobileAppDownloadUrl || "https://www.freedommortgage.com/mobileapp";
  const qrCodeImageUrl = buildImageUrl("images/servicingv2/qr-code.png");
  const appStoreBadgeUrl = buildImageUrl("images/servicingv2/badge-app-store.png");
  const googlePlayBadgeUrl = buildImageUrl("images/servicingv2/badge-google-play.png");

  return (
    <div className="relative w-full min-h-[960px] pt-[112px] pb-8">
      <RegisterSuccessDecorations />
      <div className="relative z-10 flex w-full justify-center px-4">
        <div className="w-full max-w-[760px] text-center flex flex-col items-center gap-6">
        <h1
          style={{
            color: "var(--Schemes-On-Surface, #1B1C1D)",
            fontFamily: "Canela Text",
            fontSize: "40px",
            fontStyle: "normal",
            fontWeight: 900,
            lineHeight: "normal",
            letterSpacing: "0.1px",
            margin: 0,
          }}
        >
          You’re live!
        </h1>

        <p
          style={{
            color: "var(--Sys-Background-on-background, #12202C)",
            textAlign: "center",
            fontFamily: "Poppins",
            fontSize: "13px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "normal",
            margin: 0,
            maxWidth: "560px",
          }}
        >
          Everything's set. Jump in and take control of your mortgage
        </p>

        <div className="w-full flex justify-center items-center">
          <div className="w-full max-w-[476px]">
            <Button
              variant="filled"
              fullWidth
              className="w-full"
              onClick={() => {
                navigate(
                  REGISTRATION_ROUTES.LOGIN,
                  registeredEmail
                    ? { state: { username: registeredEmail, registrationSuccess: true } }
                    : undefined,
                );
              }}
            >
              <span
                style={{
                  fontFamily: "Poppins",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "20px",
                  letterSpacing: "0.1px",
                }}
              >
                Login
              </span>
            </Button>
          </div>
        </div>

        <div className="flex items-center justify-center gap-4 w-full mt-2">
          <div
            style={{
              width: "200px",
              height: "1px",
              background: "var(--Schemes-Outline-Variant, #C4C6CC)",
            }}
          />
          <span
            style={{
              color: "var(--Sys-Background-on-background, #12202C)",
              fontFamily: "Poppins",
              fontSize: "13px",
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "normal",
              margin: 0,
            }}
          >
            OR
          </span>
          <div
            style={{
              width: "200px",
              height: "1px",
              background: "var(--Schemes-Outline-Variant, #C4C6CC)",
            }}
          />
        </div>

        <h2
          style={{
            color: "var(--Sys-Background-on-background, #12202C)",
            textAlign: "center",
            fontFamily: "Poppins",
            fontSize: "22px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "28px",
            letterSpacing: "0",
            margin: 0,
          }}
        >
          Download Our Mobile App
        </h2>

        {isWideLayout ? (
          <div className="flex flex-col items-center gap-2">
            <img
              src={qrCodeImageUrl}
              alt="QR Code"
              className="w-[220px] h-[220px] object-contain"
            />
            <p
              style={{
                color: "var(--Schemes-On-Surface, #1B1C1D)",
                fontFamily: "Poppins",
                fontSize: "11px",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "16px",
                letterSpacing: "0.5px",
                margin: 0,
              }}
            >
              Scan to download the app
            </p>
          </div>
        ) : (
          <div className="w-full max-w-[279px] flex flex-col items-center gap-4">
            <a
              href={storeListingUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full"
              aria-label="Download on the App Store"
            >
              <img
                src={appStoreBadgeUrl}
                alt="Download on the App Store"
                className="w-full h-[58px] object-contain"
              />
            </a>
            <a
              href={storeListingUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full"
              aria-label="Get it on Google Play"
            >
              <img
                src={googlePlayBadgeUrl}
                alt="Get it on Google Play"
                className="w-full h-[58px] object-contain"
              />
            </a>
          </div>
        )}
        </div>
      </div>
    </div>
  );
}
